module.exports = __webpack_public_path__ + "static/media/landingtwo.edcd88de.png";